export const paymentMethodItems = [
  { text: "Cash Collection", value: null },
  { text: "Bank Transfer", value: "withdrawal" },
  { text: "Wire Transfer", value: "invoice" },
  { text: "Credit Card", value: "card" },
];
